module.exports = __webpack_public_path__ + "static/img/mediaSlogin.63534deb.png";